import { ServiceBase } from '../../../../core/services/ServiceBase'
import Proxy from './proxy'

class Service extends ServiceBase {
  getHighLight(params) {
    return this.getData(() => Proxy.getHighLight(params))
  }

  getProvince(params) {
    return this.getData(() => Proxy.getProvince(params))
  }

  exportProvince(params) {
    return this.getFileDownload(() => Proxy.exportProvince(params))
  }

  getIndustry(params) {
    return this.getData(() => Proxy.getIndustry(params))
  }

  exportIndustry(params) {
    return this.getFileDownload(() => Proxy.exportIndustry(params))
  }

  getBusinessSize(params) {
    return this.getData(() => Proxy.getBusinessSize(params))
  }

  exportBusinessSize(params) {
    return this.getFileDownload(() => Proxy.exportBusinessSize(params))
  }

  getYearOperation(params) {
    return this.getData(() => Proxy.getYearOperation(params))
  }

  exportYearOperation(params) {
    return this.getFileDownload(() => Proxy.exportYearOperation(params))
  }

  getMaxDate(params) {
    return this.getData(() => Proxy.getMaxDate(params))
  }
}

export default new Service()
